import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  BrandGroupSelector,
  type BrandGroupSelectorProps,
} from '~/components/features/BrandGroupSelector'
import { type BrandGroup } from '~/hooks/useBrandAccountQuery'
import { useFormField } from '~/hooks/useFormField'

import { useSurvey } from '../hooks/useSurvey'
import { type InputValues } from '../utils'

export const BrandGroupInput = () => {
  const { t } = useTranslation()
  const { control, setValue } = useFormContext<InputValues>()
  const brandGroupIdField = useFormField(control, 'brandGroupId')

  const survey = useSurvey()
  const brandGroups = React.useMemo(
    () => survey?.brandGroups ?? [],
    [survey?.brandGroups],
  )

  const handleChange = React.useCallback<
    EH<BrandGroupSelectorProps<BrandGroup>, 'onChange'>
  >(
    (brandGroupId) => {
      brandGroupIdField.onChange(brandGroupId)
      setValue('brandId', null)
    },
    [brandGroupIdField, setValue],
  )

  return (
    <LabelingContainer label={t('brand_group')}>
      <BrandGroupSelector
        brandGroups={brandGroups}
        width={160}
        {...brandGroupIdField}
        onChange={handleChange}
      />
    </LabelingContainer>
  )
}
